import {clearSkillPathCache} from '../StudentSkillPath/hooks/useStudentSkillPath';
import isWelcomeRoute from '../isWelcomeRoute';
import useClassroomInvitations from '../ClassroomInvitations/hooks/useClassroomInvitations';
import useClassrooms from '../Sidebar/hooks/useClassrooms';
import useCurrentTab from './useCurrentTab';
import useIndependentPracticeSubjects from '../StudentIndependentPractice/hooks/useIndependentPracticeSubjects';
import useSyncDefaultRoute from './useSyncDefaultRoute';

export default function useOnClassroomEnrollment() {
  const {pathname} = window.location;

  const currentTab = useCurrentTab();
  const {fetchClassroomInvitations} = useClassroomInvitations();
  const {fetchClassrooms} = useClassrooms();
  const {fetchIndependentPracticeSubjects} = useIndependentPracticeSubjects();
  const {syncDefaultRoute} = useSyncDefaultRoute();

  function onClassroomEnrollment(classroomId: string | undefined) {
    clearSkillPathCache();
    fetchClassroomInvitations();
    fetchClassrooms();

    if (currentTab === 'independent-practice') {
      fetchIndependentPracticeSubjects(classroomId);
    }

    syncDefaultRoute(classroomId, pathname, !isWelcomeRoute(pathname));
  }

  return onClassroomEnrollment;
}
